import styled from "styled-components";
import { SkeletonCell } from "../../SkeletonCell";
import { CreateFormTheme } from "../../../utils/themes";

const FormFillerSkeleton = () => (
    <SkeletonContainer>
        <FileUploadSkeleton>
            <ProfileUploadSkeleton>
                <SkeletonCell style={{ width: "100px", height: "100px", borderRadius: "50%" }} />
            </ProfileUploadSkeleton>
        </FileUploadSkeleton>

        <MetadataGridSkeleton>
            {[...Array(4)].map((_, i) => (
                <MetadataFieldSkeleton key={i}>
                    <SkeletonCell style={{ width: "40%", height: "20px", marginBottom: "8px" }} />
                    <SkeletonCell style={{ height: "37px" }} />
                </MetadataFieldSkeleton>
            ))}
        </MetadataGridSkeleton>

        <FormSectionSkeleton>
            <PageHeaderSkeleton>
                <SkeletonCell style={{ width: "30%", height: "24px" }} />
                <SkeletonCell style={{ width: "20%", height: "20px" }} />
            </PageHeaderSkeleton>

            <FormFieldsSkeleton>
                {[...Array(3)].map((_, i) => (
                    <FormFieldSkeleton key={i}>
                        <SkeletonCell style={{ width: "40%", height: "20px", marginBottom: "8px" }} />
                        <SkeletonCell style={{ height: "37px" }} />
                    </FormFieldSkeleton>
                ))}
            </FormFieldsSkeleton>
        </FormSectionSkeleton>
    </SkeletonContainer>
);

export default FormFillerSkeleton;
const SkeletonContainer = styled.div`
  max-width: 900px;
  // margin: 0 auto;
  padding: 20px;
  margin-top: 50px;
`;

const FileUploadSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const ProfileUploadSkeleton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MetadataGridSkeleton = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: ${CreateFormTheme.spacing.md};
  margin-bottom: 20px;
`;

const MetadataFieldSkeleton = styled.div`
  margin-bottom: 16px;
`;

const FormSectionSkeleton = styled.div`
  background: ${CreateFormTheme.colors.addressBG};
  border-radius: 4px;
  border: 1px solid ${CreateFormTheme.colors.border};
  padding: 20px;
  margin-top: 20px;
`;

const PageHeaderSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const FormFieldsSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormFieldSkeleton = styled.div`
  margin-bottom: 16px;
`;